/* eslint-disable complexity */
import {
	Card,
	Center,
	Flex,
	For,
	HStack,
	Progress,
	Stack,
	Text,
} from '@chakra-ui/react';

import { Rating } from '@packages/chakra-v3';

type ProductReviewSummaryCardProps = {
	productReviewSummary: {
		totalRating:    number;
		totalReview:    number;
		oneStarCount:   number;
		twoStarCount:   number;
		threeStarCount: number;
		fourStarCount:  number;
		fiveStarCount:  number;
	};
};

const ProductReviewSummaryCard = ({ productReviewSummary }: ProductReviewSummaryCardProps) => {
	const {
		totalRating,
		totalReview,
		oneStarCount,
		twoStarCount,
		threeStarCount,
		fourStarCount,
		fiveStarCount,
	} = productReviewSummary;

	const rating = totalRating / (totalReview || 1);
	const progressValues = [
		{
			value:    5,
			count:    fiveStarCount,
			progress: fiveStarCount / totalReview * 100 || 0,
		},
		{
			value:    4,
			count:    fourStarCount,
			progress: fourStarCount / totalReview * 100 || 0,
		},
		{
			value:    3,
			count:    threeStarCount,
			progress: threeStarCount / totalReview * 100 || 0,
		},
		{
			value:    2,
			count:    twoStarCount,
			progress: twoStarCount / totalReview * 100 || 0,
		},
		{
			value:    1,
			count:    oneStarCount,
			progress: oneStarCount / totalReview * 100 || 0,
		},
	];

	return (
		<Card.Root>
			<Card.Header>
				<Card.Title>Customer Reviews</Card.Title>
			</Card.Header>
			<Card.Body>
				<Flex alignItems={'center'} flexWrap={'wrap'} gap={8}>
					<Center flex={1} gap={2}>
						<Stack alignItems={'center'} gap={2}>
							<Text fontSize={'42px'} lineHeight={1}>{rating}</Text>
							<Rating
								allowHalf
								readOnly
								defaultValue={rating}
								size={'lg'}
							/>
							<Text textStyle={'p2'}>{totalReview} reviews</Text>
						</Stack>
					</Center>
					<Stack flex={2} maxW={'600px'} minW={'300px'}>
						<For each={progressValues}>
							{value => (
								<HStack key={value.value} alignItems={'start'} gap={4}>
									<Progress.Root
										size={'lg'}
										value={value.progress}
										w={'full'}
									>
										<HStack>
											<Progress.Label
												alignItems={'center'}
												minW={'40px'}
												textStyle={'p3'}
											>
												<Rating count={1} value={1} />
												{value.value}
											</Progress.Label>
											<Progress.Track flex={1}>
												<Progress.Range />
											</Progress.Track>
											<Progress.ValueText minW={'40px'} ml={4} textStyle={'p3'}>{value.count}</Progress.ValueText>
										</HStack>
									</Progress.Root>
								</HStack>
							)}
						</For>
					</Stack>
				</Flex>
			</Card.Body>
			<Card.Footer />
		</Card.Root>
	);
};

export default ProductReviewSummaryCard;